import { timelineEvents } from "@/mocks/homeData";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full border-y border-background-200 bg-background-100">
      <div className="w-full px-4 py-10 md:px-8 md:py-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[320px_1fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-timeline-view text-lg" style={{ lineHeight: 1 }} />
              </span>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">完整时间线</h2>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              从第一条动态到最新一次改口，按发生顺序逐条排列。每个节点都标注了当时的公开表述，方便你对照着看
              来龙去脉，判断哪一步才是真正的关键。
            </p>

            <div className="mt-5 grid grid-cols-2 gap-3">
              <div className="rounded-lg border border-background-200 bg-background-50 p-3">
                <div className="font-label text-xl font-bold text-primary-600">11</div>
                <div className="mt-1 text-xs text-foreground-500">天完整跨度</div>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-3">
                <div className="font-label text-xl font-bold text-accent-600">6</div>
                <div className="mt-1 text-xs text-foreground-500">个关键节点</div>
              </div>
            </div>

            <button
              type="button"
              className="mt-4 w-full cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 py-3 text-sm font-medium text-background-50 transition-opacity hover:opacity-90"
            >
              展开全部 86 个节点
            </button>
          </div>

          <ol className="relative ml-3 border-l-2 border-background-300 pl-6">
            {timelineEvents.map((event, index) => (
              <li
                key={event.title}
                className="reveal relative pb-7 last:pb-0"
                style={{ animationDelay: `${index * 70}ms` }}
              >
                <span
                  className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-100 ${
                    event.tag === "关键" ? "bg-accent-500" : "bg-primary-500"
                  }`}
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                </span>

                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-label text-sm font-semibold text-foreground-900">{event.date}</span>
                  <span className="font-label text-xs text-foreground-400">{event.time}</span>
                  <span
                    className={`rounded-sm px-2 py-0.5 text-[11px] font-medium ${
                      event.tag === "关键"
                        ? "bg-accent-100 text-accent-800"
                        : event.tag === "反转"
                          ? "bg-primary-100 text-primary-800"
                          : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {event.tag}
                  </span>
                </div>

                <h3 className="mt-2 text-sm font-bold text-foreground-950 md:text-base">{event.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{event.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}